import * as n from "@dimforge/rapier3d-compat";
import { ActiveEvents as po, ActiveCollisionTypes as no } from "@dimforge/rapier3d-compat";
import { defineQuery as uo } from "bitecs";
import { NULL_ENTITY as G, TIME_CONSTANTS as mo } from "../../core/ecs/constants.js";
import "../../core/ecs/components.js";
import { quaternionToEuler as to, eulerToQuaternion as fo } from "../../core/math/utils.js";
import "three";
import "../../core/validation/schemas.js";
import { Transform as p, WorldTransform as z } from "../transforms/components.js";
import "../transforms/systems.js";
import { syncEulerFromQuaternion as vo } from "../transforms/utils.js";
import { InterpolatedTransform as c, CharacterController as C, Body as r, CharacterMovement as i, BodyType as Y, ApplyForce as M, ApplyTorque as F, ApplyImpulse as K, ApplyAngularImpulse as N, SetLinearVelocity as R, SetAngularVelocity as E, KinematicAngularVelocity as w, KinematicMove as D, KinematicRotate as B, ColliderShape as _ } from "./components.js";
const Do = -60;
let j = !1;
async function ho() {
  j || (await n.init(), j = !0);
}
const io = uo([c]);
function Po(o, s, e) {
  let l;
  switch (o) {
    case Y.Fixed:
      l = n.RigidBodyDesc.fixed();
      break;
    case Y.Dynamic:
      l = n.RigidBodyDesc.dynamic();
      break;
    case Y.KinematicVelocityBased:
      l = n.RigidBodyDesc.kinematicVelocityBased();
      break;
    case Y.KinematicPositionBased:
      l = n.RigidBodyDesc.kinematicPositionBased();
      break;
    default:
      l = n.RigidBodyDesc.dynamic();
  }
  return s && l.setTranslation(s.x, s.y, s.z), e && l.setRotation(e), l;
}
function Wo(o, s, e, l, a, u, m, t, f, V, X, Z, d) {
  e === Y.Dynamic && l > 0 && o.setAdditionalMass(l, !0), o.setLinvel(a, !0), o.setAngvel(u, !0), o.setLinearDamping(m), o.setAngularDamping(t), o.setGravityScale(f, !0), o.enableCcd(!!V), (X || Z || d) && o.setEnabledRotations(!X, !Z, !d, !0);
}
function Ao(o, s, e, l, a, u, m, t, f, V, X, Z, d, g, P = po.NONE) {
  let v;
  switch (o) {
    case _.Box:
      v = n.ColliderDesc.cuboid(s / 2, e / 2, l / 2);
      break;
    case _.Sphere:
      v = n.ColliderDesc.ball(s / 2);
      break;
    case _.Capsule:
      v = n.ColliderDesc.capsule(u / 2, a);
      break;
    default:
      v = n.ColliderDesc.cuboid(0.5, 0.5, 0.5);
  }
  v.setFriction(m), v.setRestitution(t), V ? (v.setSensor(!0), v.setDensity(0)) : v.setDensity(f);
  const W = X || 65535, A = Z || 65535;
  return v.setCollisionGroups(W & 65535 | (A & 65535) << 16), v.setTranslation(d.x, d.y, d.z), v.setRotation(g), v.activeEvents = P, v.activeCollisionTypes = no.DEFAULT, v;
}
function So(o, s, e) {
  r.type[o] === Y.Dynamic && s.addForce(
    new n.Vector3(
      M.x[o],
      M.y[o],
      M.z[o]
    ),
    !0
  ), e.removeComponent(o, M);
}
function Bo(o, s, e) {
  r.type[o] === Y.Dynamic && s.addTorque(
    new n.Vector3(
      F.x[o],
      F.y[o],
      F.z[o]
    ),
    !0
  ), e.removeComponent(o, F);
}
function Io(o, s, e) {
  r.type[o] === Y.Dynamic && s.applyImpulse(
    new n.Vector3(
      K.x[o],
      K.y[o],
      K.z[o]
    ),
    !0
  ), e.removeComponent(o, K);
}
function Mo(o, s, e) {
  r.type[o] === Y.Dynamic && s.applyTorqueImpulse(
    new n.Vector3(
      N.x[o],
      N.y[o],
      N.z[o]
    ),
    !0
  ), e.removeComponent(o, N);
}
function Fo(o, s, e) {
  const l = r.type[o];
  if (l === Y.Dynamic) {
    const a = s.linvel(), u = new n.Vector3(
      R.x[o],
      R.y[o],
      R.z[o]
    ), m = new n.Vector3(
      u.x - a.x,
      u.y - a.y,
      u.z - a.z
    ), t = s.mass(), f = new n.Vector3(
      m.x * t,
      m.y * t,
      m.z * t
    );
    s.applyImpulse(f, !0);
  } else l === Y.KinematicVelocityBased && s.setLinvel(
    new n.Vector3(
      R.x[o],
      R.y[o],
      R.z[o]
    ),
    !0
  );
  e.removeComponent(o, R);
}
function Ko(o, s, e) {
  const l = r.type[o];
  if (l === Y.Dynamic) {
    const a = s.angvel(), u = new n.Vector3(
      E.x[o],
      E.y[o],
      E.z[o]
    ), m = new n.Vector3(
      u.x - a.x,
      u.y - a.y,
      u.z - a.z
    ), t = s.principalInertia(), f = new n.Vector3(
      m.x * t.x,
      m.y * t.y,
      m.z * t.z
    );
    s.applyTorqueImpulse(f, !0);
  } else if (l === Y.KinematicVelocityBased) {
    const a = E.x[o], u = E.y[o], m = E.z[o];
    s.setAngvel(new n.Vector3(a, u, m), !0), e.hasComponent(o, w) || e.addComponent(o, w), w.x[o] = a, w.y[o] = u, w.z[o] = m;
  }
  e.removeComponent(o, E);
}
function No(o, s, e) {
  const l = r.type[o];
  if (l === Y.KinematicPositionBased)
    s.setNextKinematicTranslation(
      new n.Vector3(
        D.x[o],
        D.y[o],
        D.z[o]
      )
    );
  else if (l === Y.KinematicVelocityBased) {
    const a = s.translation(), u = D.x[o], m = D.y[o], t = D.z[o], f = mo.FIXED_TIMESTEP;
    s.setLinvel(
      new n.Vector3(
        (u - a.x) / f,
        (m - a.y) / f,
        (t - a.z) / f
      ),
      !0
    );
  }
  e.removeComponent(o, D);
}
function qo(o, s, e) {
  r.type[o] === Y.KinematicPositionBased && s.setNextKinematicRotation(
    new n.Quaternion(
      B.x[o],
      B.y[o],
      B.z[o],
      B.w[o]
    )
  ), e.removeComponent(o, B);
}
function Lo(o, s) {
  const e = s.translation(), l = s.rotation(), a = e.x !== r.posX[o] || e.y !== r.posY[o] || e.z !== r.posZ[o], u = l.x !== r.rotX[o] || l.y !== r.rotY[o] || l.z !== r.rotZ[o] || l.w !== r.rotW[o];
  a && (s.setTranslation(
    new n.Vector3(
      r.posX[o],
      r.posY[o],
      r.posZ[o]
    ),
    !0
  ), c.prevPosX[o] !== void 0 && (c.prevPosX[o] = r.posX[o], c.prevPosY[o] = r.posY[o], c.prevPosZ[o] = r.posZ[o], c.posX[o] = r.posX[o], c.posY[o] = r.posY[o], c.posZ[o] = r.posZ[o])), u && (s.setRotation(
    new n.Quaternion(
      r.rotX[o],
      r.rotY[o],
      r.rotZ[o],
      r.rotW[o]
    ),
    !0
  ), c.prevRotX[o] !== void 0 && (c.prevRotX[o] = r.rotX[o], c.prevRotY[o] = r.rotY[o], c.prevRotZ[o] = r.rotZ[o], c.prevRotW[o] = r.rotW[o], c.rotX[o] = r.rotX[o], c.rotY[o] = r.rotY[o], c.rotZ[o] = r.rotZ[o], c.rotW[o] = r.rotW[o]));
}
function Yo(o, s, e, l) {
  const u = s.translation(), m = s.rotation(), t = new n.Vector3(0, -1, 0), f = s.shape, V = e.castShape(
    u,
    m,
    t,
    f,
    0.15,
    0.15,
    !0,
    n.QueryFilterFlags.EXCLUDE_SENSORS,
    void 0,
    void 0,
    void 0,
    (X) => X.handle !== s.handle
  );
  if (V) {
    const X = V.collider.handle, Z = l.get(X);
    if (Z !== void 0 && Z !== o && V.normal1.y > 0.7)
      return Z;
  }
  return G;
}
function Qo(o, s, e, l, a, u, m, t) {
  const f = C.grounded[o] === 1, V = r.gravityScale[o], X = u * V;
  f ? i.velocityY[o] < 0 && (i.velocityY[o] = 0) : i.velocityY[o] = (i.velocityY[o] || 0) + X * a;
  const Z = (i.velocityY[o] || 0) + (i.desiredVelY[o] || 0);
  let d = 0, g = 0, P = 0, v = 0, W = 0, A = 0;
  const x = C.platform[o];
  if (f && x !== G) {
    r.type[x] === Y.KinematicVelocityBased && (d = r.velX[x] || 0, g = r.velY[x] || 0, P = r.velZ[x] || 0);
    const S = r.rotVelX[x] || 0, Q = r.rotVelY[x] || 0, k = r.rotVelZ[x] || 0;
    if (S !== 0 || Q !== 0 || k !== 0) {
      const ro = r.posX[o], eo = r.posY[o], so = r.posZ[o], co = r.posX[x], ao = r.posY[x], lo = r.posZ[x], U = ro - co, H = eo - ao, $ = so - lo;
      v = Q * $ - k * H, W = k * U - S * $, A = S * H - Q * U;
    }
  }
  C.platformVelX[o] = d + v, C.platformVelY[o] = g + W, C.platformVelZ[o] = P + A;
  const J = new n.Vector3(
    (i.desiredVelX[o] + d + v) * a,
    (Z + g + W) * a,
    (i.desiredVelZ[o] + P + A) * a
  );
  s.computeColliderMovement(
    e,
    J,
    n.QueryFilterFlags.EXCLUDE_SENSORS,
    void 0,
    (I) => I.handle !== e.handle
  );
  const h = s.computedMovement(), O = Math.sqrt(
    i.desiredVelX[o] ** 2 + i.desiredVelZ[o] ** 2
  ), b = Math.sqrt(
    (h.x / a) ** 2 + (h.z / a) ** 2
  ), y = O > 0.1 && b < O * 0.1;
  let T = h;
  if (y && i.velocityY[o] > 0) {
    const I = -i.desiredVelX[o] * 1e-3, S = -i.desiredVelZ[o] * 1e-3;
    T = new n.Vector3(
      h.x + I,
      h.y,
      h.z + S
    );
  }
  const q = l.translation(), oo = new n.Vector3(
    q.x + T.x,
    q.y + T.y,
    q.z + T.z
  );
  l.setNextKinematicTranslation(oo), i.actualMoveX[o] = T.x, i.actualMoveY[o] = T.y, i.actualMoveZ[o] = T.z, C.moveX[o] = T.x, C.moveY[o] = T.y, C.moveZ[o] = T.z;
  const L = s.computedGrounded() ? 1 : 0;
  C.grounded[o] = L, L ? C.platform[o] = Yo(
    o,
    e,
    t,
    m
  ) : C.platform[o] = G, L && !f && (i.velocityY[o] = 0);
}
function ko(o, s) {
  for (const e of io(o.world)) {
    if (!o.hasComponent(e, p))
      throw new Error(
        `[interpolateTransforms] Entity ${e} does not have the required components`
      );
    p.posX[e] = c.prevPosX[e] * (1 - s) + c.posX[e] * s, p.posY[e] = c.prevPosY[e] * (1 - s) + c.posY[e] * s, p.posZ[e] = c.prevPosZ[e] * (1 - s) + c.posZ[e] * s;
    const l = c.prevRotW[e], a = c.prevRotX[e], u = c.prevRotY[e], m = c.prevRotZ[e], t = c.rotW[e], f = c.rotX[e], V = c.rotY[e], X = c.rotZ[e];
    let Z = l * t + a * f + u * V + m * X;
    const d = 1 - s;
    Z < 0 ? (p.rotW[e] = l * d - t * s, p.rotX[e] = a * d - f * s, p.rotY[e] = u * d - V * s, p.rotZ[e] = m * d - X * s) : (p.rotW[e] = l * d + t * s, p.rotX[e] = a * d + f * s, p.rotY[e] = u * d + V * s, p.rotZ[e] = m * d + X * s);
    const g = Math.sqrt(
      p.rotW[e] * p.rotW[e] + p.rotX[e] * p.rotX[e] + p.rotY[e] * p.rotY[e] + p.rotZ[e] * p.rotZ[e]
    );
    g > 1e-3 && (p.rotW[e] /= g, p.rotX[e] /= g, p.rotY[e] /= g, p.rotZ[e] /= g), vo(p, e);
  }
}
function _o(o, s, e) {
  const l = s.translation(), a = s.rotation(), u = s.linvel();
  r.posX[o] = l.x, r.posY[o] = l.y, r.posZ[o] = l.z, r.rotX[o] = a.x, r.rotY[o] = a.y, r.rotZ[o] = a.z, r.rotW[o] = a.w;
  const m = to(
    a.x,
    a.y,
    a.z,
    a.w
  );
  if (r.eulerX[o] = m.x, r.eulerY[o] = m.y, r.eulerZ[o] = m.z, r.velX[o] = u.x, r.velY[o] = u.y, r.velZ[o] = u.z, e.hasComponent(o, w))
    r.rotVelX[o] = w.x[o], r.rotVelY[o] = w.y[o], r.rotVelZ[o] = w.z[o];
  else {
    const t = s.angvel();
    r.rotVelX[o] = t.x, r.rotVelY[o] = t.y, r.rotVelZ[o] = t.z;
  }
}
function Go(o, s) {
  if (!s.hasComponent(o, p) || !s.hasComponent(o, z) || !s.hasComponent(o, c))
    throw new Error(
      `[copyRigidbodyToTransforms] Entity ${o} does not have the required components`
    );
  p.posX[o] = r.posX[o], p.posY[o] = r.posY[o], p.posZ[o] = r.posZ[o], p.rotX[o] = r.rotX[o], p.rotY[o] = r.rotY[o], p.rotZ[o] = r.rotZ[o], p.rotW[o] = r.rotW[o], p.eulerX[o] = r.eulerX[o], p.eulerY[o] = r.eulerY[o], p.eulerZ[o] = r.eulerZ[o], z.posX[o] = r.posX[o], z.posY[o] = r.posY[o], z.posZ[o] = r.posZ[o], z.rotX[o] = r.rotX[o], z.rotY[o] = r.rotY[o], z.rotZ[o] = r.rotZ[o], z.rotW[o] = r.rotW[o], z.eulerX[o] = r.eulerX[o], z.eulerY[o] = r.eulerY[o], z.eulerZ[o] = r.eulerZ[o], c.prevPosX[o] = c.posX[o], c.prevPosY[o] = c.posY[o], c.prevPosZ[o] = c.posZ[o], c.prevRotX[o] = c.rotX[o], c.prevRotY[o] = c.rotY[o], c.prevRotZ[o] = c.rotZ[o], c.prevRotW[o] = c.rotW[o], c.posX[o] = r.posX[o], c.posY[o] = r.posY[o], c.posZ[o] = r.posZ[o], c.rotX[o] = r.rotX[o], c.rotY[o] = r.rotY[o], c.rotZ[o] = r.rotZ[o], c.rotW[o] = r.rotW[o];
}
function Oo(o) {
  const s = fo(
    r.eulerX[o],
    r.eulerY[o],
    r.eulerZ[o]
  );
  r.rotX[o] = s.x, r.rotY[o] = s.y, r.rotZ[o] = s.z, r.rotW[o] = s.w;
}
export {
  Do as DEFAULT_GRAVITY,
  Mo as applyAngularImpulseToEntity,
  Qo as applyCharacterMovement,
  So as applyForceToEntity,
  Io as applyImpulseToEntity,
  No as applyKinematicMove,
  qo as applyKinematicRotation,
  Bo as applyTorqueToEntity,
  Wo as configureRigidbody,
  Go as copyRigidbodyToTransforms,
  Ao as createColliderDescriptor,
  Po as createRigidbodyDescriptor,
  Yo as detectPlatformContinuous,
  ho as initializePhysics,
  ko as interpolateTransforms,
  Ko as setAngularVelocityForEntity,
  Fo as setLinearVelocityForEntity,
  Oo as syncBodyQuaternionFromEuler,
  _o as syncRigidbodyToECS,
  Lo as teleportEntity
};
//# sourceMappingURL=utils.js.map
